import React from 'react';
import AddOrEditTransporterForm from './AddOrEditTransporterForm';

/* React functional component */
const CreateTransporterScreen = () => {
  return <AddOrEditTransporterForm mode="add" />;
};

export default CreateTransporterScreen;
